import { render, staticRenderFns } from "./RequestInfo.vue?vue&type=template&id=a3f0d60e&scoped=true&"
import script from "./RequestInfo.vue?vue&type=script&lang=js&"
export * from "./RequestInfo.vue?vue&type=script&lang=js&"
import style0 from "./RequestInfo.vue?vue&type=style&index=0&id=a3f0d60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f0d60e",
  null
  
)

export default component.exports